import React, { useEffect, useState, useRef } from 'react';
import { BookOpen, Calendar, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const [isInteracting, setIsInteracting] = useState(false);
  const cards = [{
    icon: <BookOpen className="w-8 h-8 text-serene-blue" data-id="element-121" />,
    title: 'LEE',
    text: 'Abre el día que corresponde y encuentra una oración clara, simple y lista para usar.',
    color: 'bg-serene-blue/10'
  }, {
    icon: <Calendar className="w-8 h-8 text-warm-orange" data-id="element-122" />,
    title: 'CONECTA',
    text: 'Dedica solo 2 minutos al día para hablar con Dios, sin presión ni complicaciones.',
    color: 'bg-warm-orange/10'
  }, {
    icon: <Sparkles className="w-8 h-8 text-sage-green" data-id="element-123" />,
    title: 'SIENTE',
    text: 'Experimenta paz, claridad y una conexión real con Dios desde el primer día.',
    color: 'bg-sage-green/10'
  }];
  // Detectar card activa centrada
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const children = Array.from(scrollRef.current.children);
    const containerRect = scrollRef.current.getBoundingClientRect();
    const center = containerRect.left + containerRect.width / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;
    children.forEach((child, i) => {
      const rect = (child as HTMLElement).getBoundingClientRect();
      const childCenter = rect.left + rect.width / 2;
      const distance = Math.abs(center - childCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    });
    setActive(closestIndex);
  };
  // Autoplay inteligente
  useEffect(() => {
    const interval = setInterval(() => {
      if (isInteracting || !scrollRef.current) return;
      const next = (active + 1) % cards.length;
      const container = scrollRef.current;
      const child = container.children[next] as HTMLElement;
      container.scrollTo({
        left: child.offsetLeft - container.offsetWidth / 2 + child.offsetWidth / 2,
        behavior: 'smooth'
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [active, isInteracting]);
  return <>
      {/* Ocultar scrollbar */}
      <style data-id="element-124">
        {`
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .no-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>

      <section className="py-20 px-6 bg-serene-blue" data-id="element-125">
        <div className="max-w-6xl mx-auto" data-id="element-126">
          {/* HEADER */}
          <div className="text-center mb-16" data-id="element-127">
            <h2 className="font-fredoka text-3xl md:text-5xl text-white mb-4" data-id="element-128">
              La forma más simple de hablar con Dios cada día
            </h2>
            <p className="text-xl md:text-2xl text-white/90 font-bold font-nunito" data-id="element-129">
              365 Oraciones listas para usar, sin esfuerzo
            </p>
          </div>

          {/* CARRUSEL */}
          <div ref={scrollRef} onScroll={handleScroll} onMouseEnter={() => setIsInteracting(true)} onMouseLeave={() => setIsInteracting(false)} onTouchStart={() => setIsInteracting(true)} onTouchEnd={() => setIsInteracting(false)} className="flex gap-6 overflow-x-auto no-scrollbar scroll-smooth snap-x snap-mandatory px-6" data-id="element-130">
            {cards.map((card, i) => <div key={i} className={`min-w-[260px] md:min-w-[320px] snap-center rounded-3xl p-8 text-center transition-all duration-700 ${i === active ? 'bg-white scale-105 opacity-100 shadow-2xl' : 'bg-white/90 scale-90 opacity-40 blur-[2px]'} hover:scale-105 hover:opacity-100 hover:blur-0`} data-id="element-131">
                <div className={`w-16 h-16 ${card.color} rounded-full flex items-center justify-center mx-auto mb-6 transition-all duration-500`} data-id="element-132">
                  {card.icon}
                </div>

                <h3 className="font-fredoka text-2xl text-charcoal mb-4" data-id="element-133">
                  {card.title}
                </h3>

                <p className="text-gray-600 font-medium leading-relaxed" data-id="element-134">
                  {card.text}
                </p>
              </div>)}
          </div>

          {/* INDICADORES */}
          <div className="flex justify-center gap-3 mt-6" data-id="element-135">
            {cards.map((_, i) => <div key={i} className={`h-2 rounded-full transition-all duration-500 ${i === active ? 'w-6 bg-white' : 'w-2 bg-white/40'}`} data-id="element-136" />)}
          </div>

          {/* IMAGEN */}
          <div className="max-w-3xl mx-auto mt-16 mb-12" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/4yXZRTRYymTtKd7qvhTxW2/Image_fx_(14).png" alt="365 Oraciones en acción" className="w-full h-auto rounded-3xl shadow-2xl" data-id="element-138" />
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-139">
            <button className="bg-white text-sage-green hover:bg-gray-50 font-bold text-xl py-4 px-10 rounded-2xl shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all duration-300" data-id="element-140">
              Empieza hoy tu conexión con Dios
            </button>
          </div>
        </div>
      </section>
    </>;
}